module.exports = __webpack_public_path__ + "img/1440.88adea38.jpg";